__webpack_require__.p = "/sc/pricelist/";